export enum Operator {
  gt = 'gt',
  gte = 'gte',
  eq = 'eq',
  lte = 'lte',
  lt = 'lt',
}

export const defaultOperatorArr = [
  Operator.gt,
  Operator.gte,
  Operator.eq,
  Operator.lte,
  Operator.lt,
];

export enum OperatorSymbol {
  gt = '>',
  gte = '≥',
  eq = '=',
  lte = '≤',
  lt = '<',
}

export const operatorSymbolsMap: Record<Operator, OperatorSymbol> = {
  [Operator.gt]: OperatorSymbol.gt,
  [Operator.gte]: OperatorSymbol.gte,
  [Operator.eq]: OperatorSymbol.eq,
  [Operator.lte]: OperatorSymbol.lte,
  [Operator.lt]: OperatorSymbol.lt,
};
